import React from 'react';

interface ErrorScreenProps {
  message: string;
}

export default function ErrorScreen({ message }: ErrorScreenProps) {
  return (
    <div className="max-w-md mx-auto p-6 bg-destructive/5 rounded-lg border border-destructive/20">
      <h1 className="text-2xl font-bold text-destructive mb-4">Onboarding Error</h1>
      <p className="text-destructive/90">{message}</p>
    </div>
  );
}
